export type CombineId =
  | 'monitoring'
  | 'site'
  | 'drone'
  | 'environmental'
  | 'utils'
  | 'topo'
  | 'maps'
  | 'bim'
  | 'pointCloud'
  | 'hydro';

export type Combine = {
  id: CombineId;
  name: string;
  svgIds: string[];
  colour: 'green' | 'blue';
};

export const allCombines: Record<CombineId, Combine> = {
  // greens
  monitoring: {
    id: 'monitoring',
    name: 'Monitoring',
    colour: 'green',
    svgIds: ['g_x5F_ctx_x5F_monitoring'],
  },
  site: {
    id: 'site',
    name: 'Site Photos',
    colour: 'green',
    svgIds: ['g_x5F_ctx_x5F_site_x5F_photos'],
  },
  drone: {
    id: 'drone',
    name: 'Drone',
    colour: 'green',
    svgIds: ['g_x5F_ctx_x5F_drone', 'g_x5F_ctx_x5F_drone_x5F_floor'],
  },
  environmental: {
    id: 'environmental',
    name: 'Environmental',
    colour: 'green',
    svgIds: ['g_x5F_ctx_x5F_environmental'],
  },
  utils: { id: 'utils', name: 'Utilities', colour: 'green', svgIds: ['g_x5F_ctx_x5F_utils'] },
  topo: { id: 'topo', name: 'Topographic', colour: 'green', svgIds: ['g_x5F_ctx_x5F_topo'] },
  maps: { id: 'maps', name: 'Maps', colour: 'green', svgIds: ['g_x5F_ctx_x5F_maps'] },

  // blues
  bim: { id: 'bim', name: 'BIM', colour: 'blue', svgIds: ['g_x5F_ctx_x5F_bim'] },
  pointCloud: {
    id: 'pointCloud',
    colour: 'blue',
    name: 'Point Cloud',
    svgIds: ['g_x5F_ctx_x5F_point_x5F_cloud'],
  },
  hydro: { id: 'hydro', name: 'Hydrographic', colour: 'blue', svgIds: ['g_x5F_ctx_x5F_hydro'] },
};
